module.exports = __webpack_public_path__ + "static/media/close.dac109c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Frontend/assets/iconos/close.svg
// module id = 6
// module chunks = 0